export default IconNumber9 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-number-9" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0" />
  <path d="M8 16a4 4 0 1 0 8 0v-8" />
</svg>`;